import { mapState } from 'vuex'
export default {
	name: 'Index',
	computed: {
		...mapState({
			supportCountryAndLanguage: (state) =>
				state.settings.supportCountryAndLanguage,
			globalFlag: (state) => state.settings.globalFlag,
		}),
	},
	watch: {
		supportCountryAndLanguage(value) {
			if (value && this.$route?.query?.c) {
				const findCountryByCurrency = value.find(
					(el) =>
						el.currency_code === this.$route?.query?.c.toUpperCase()
				)
				if (findCountryByCurrency) {
					this.$cookie.remove('country')
					this.$cookie.remove('country_code')

					this.$cookie.set(
						'country',
						findCountryByCurrency.country_code
					)
					this.$cookie.set(
						'country_code',
						findCountryByCurrency.country_code
					)
					this.$cookie.set(
						'global_reg',
						findCountryByCurrency.country_code
					)
					this.$store.commit(
						'settings/setGlobalFlag',
						findCountryByCurrency.country_code
					)
				}
			}
		},
	},
	created() {
		// In case, the article url has query string (currency and language), and we try to change the languages.
		// The language is not gonna be changed. That's why we must have this condition.
		if (!this.$cookie?.get('is_change_language')) {
			if (this.$route?.query?.c) {
				this.$cookie.set('currency', this.$route?.query?.c?.toUpperCase())

				// This is to set the sitemap link country to be match the flag
				const findMatchCurrency = this.$store.state.settings.supportCountryAndLanguage.find(el => el?.currency_code?.toLowerCase() === this.$route?.query?.c?.toLowerCase())
				if (findMatchCurrency) {
					this.$cookie.set('country_code', findMatchCurrency?.country_code)
					this.$store.commit('settings/setGlobalFlag', findMatchCurrency?.country_code)
				}
			}

			if (this.$route?.query?.l) {
				const lang = this.$route?.query?.l
				const regex = /^[a-zA-Z]{2}-[a-zA-Z]{2}$/ // language checking regex

				if (regex.test(lang)) {
					this.$store.dispatch('base-settings/updateLocaleAndSetCookie', lang)
				} else {
					const first5CharForLanguageCode = lang?.slice(0, 5)
					if (regex.test(first5CharForLanguageCode)) {
						this.$store.dispatch('base-settings/updateLocaleAndSetCookie', first5CharForLanguageCode)
					}
				}
			}
		}
	},
}